(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29603],{

/***/ 85639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50998);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.body1, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ListItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      dense: classes.dense
    }, ListItemClasses),
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),

/***/ 68432:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
}), 'Tune');

exports.Z = _default;

/***/ }),

/***/ 94397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
}), 'UnfoldMore'));

/***/ }),

/***/ 98525:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterListSharp');
exports.Z = _default;

/***/ }),

/***/ 60881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(22564);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(73637);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36456);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31567);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86700);
/* harmony import */ var _redux_actions_taxons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44279);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8122);
/* harmony import */ var _components_Hero_HeroSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87170);
/* harmony import */ var _components_Shop_Catalog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54972);
/* harmony import */ var _components_Shop_Shop_style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45889);
/* harmony import */ var _components_Loader_Loader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96149);
/* harmony import */ var _components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94455);
/* harmony import */ var _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86730);
/* harmony import */ var _redux_actions_prismic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64063);
/* harmony import */ var _utils_gtag__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(65809);
/* provided dependency */ var process = __webpack_require__(34155);


















var mapStateToProps = function(state) {
    return {
        taxons: state.taxons,
        cart: state.cart,
        products: state.products,
        stock: state.stock,
        parameters: state.parameters
    };
};
var mapDispatchToProps = {
    getTaxons: _redux_actions_taxons__WEBPACK_IMPORTED_MODULE_4__/* .getTaxons */ .xI,
    getProductsByTaxonsSlug: _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__/* .getProductsByTaxonsSlug */ .R2,
    getCumulativeProductsByTaxonsSlug: _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__/* .getCumulativeProductsByTaxonsSlug */ .Or,
    setCurrentSlug: _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__/* .setCurrentSlug */ .re,
    setCurrentSearch: _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__/* .setCurrentSearch */ .BE,
    emptyProductState: _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__/* .emptyProductState */ .XD,
    filterProductsAction: _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__/* .filterProductsAction */ .bj,
    filterCumulativeProductsAction: _redux_actions_products__WEBPACK_IMPORTED_MODULE_11__/* .filterCumulativeProductsAction */ .p1
};
var Shop = function(param) {
    var doc = param.doc, basket = param.basket, takeback = param.takeback, inStoreText = param.inStoreText, main = param.main, funnel = param.funnel, classic_sub = param.classic_sub, filterProductsAction1 = param.filterProductsAction, filterCumulativeProductsAction1 = param.filterCumulativeProductsAction, getCumulativeProductsByTaxonsSlug1 = param.getCumulativeProductsByTaxonsSlug, setCurrentSearch1 = param.setCurrentSearch, getProductsByTaxonsSlug1 = param.getProductsByTaxonsSlug, cart = param.cart, stock = param.stock, pageData = param.pageData, products = param.products, accountRes = param.accountRes, faqRes = param.faqRes, banner = param.banner;
    var ref27, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(router.query.q), search = ref20[0];
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var classes = (0,_components_Shop_Shop_style__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({});
    var ref21 = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(), trackPageView = ref21.trackPageView, trackEvent = ref21.trackEvent;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDrawerOpen = ref22[0], setIsDrawerOpen = ref22[1];
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoadingProductsAndStocks = ref23[0], setIsLoadingProductsAndStocks = ref23[1];
    var page1 = typeof (router === null || router === void 0 ? void 0 : (ref27 = router.query) === null || ref27 === void 0 ? void 0 : ref27.currentPage) !== 'undefined' ? typeof (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.currentPage) === 'string' ? router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.currentPage : (router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.currentPage) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && (router === null || router === void 0 ? void 0 : (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.currentPage[0]) : '1';
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(typeof page1 !== 'undefined' ? parseInt(page1) : 1), currentPage = ref24[0], setCurrentPage = ref24[1];
    var ref25 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isHandleMore = ref25[0], setIsHandleMore = ref25[1];
    var columnLayout = main === null || main === void 0 ? void 0 : (ref6 = main.data) === null || ref6 === void 0 ? void 0 : ref6.page_shop_layout;
    var settings = main === null || main === void 0 ? void 0 : main.data;
    var isMobileAccordion = doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.is_display_accordion_on_mobile_page;
    var loadMore = doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.pagination_mode;
    var productToLoadLimit = (doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.product_limit_per_load) !== null ? doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.product_limit_per_load : 48;
    var getProducts = function() {
        var isCumulative = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, nextPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var filtersFromUrl = router.query.filters;
        var page = nextPage ? currentPage + 1 : currentPage;
        if (isCumulative) {
            if (process.env.NEXT_PUBLIC_ENABLE_ALGOLIA === 'true') {
                filterCumulativeProductsAction1(Array.isArray(search) ? search.join(' ') : search, page, productToLoadLimit, router.locale);
            } else {
                getCumulativeProductsByTaxonsSlug1(null, productToLoadLimit, page, filtersFromUrl ? JSON.parse(filtersFromUrl) : [], search);
            }
        } else {
            if (process.env.NEXT_PUBLIC_ENABLE_ALGOLIA === 'true') {
                filterProductsAction1(Array.isArray(search) ? search.join(' ') : search, page, productToLoadLimit, router.locale);
            } else {
                getProductsByTaxonsSlug1(null, 48, page, filtersFromUrl ? JSON.parse(filtersFromUrl) : [], search);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        dispatch((0,_redux_actions_prismic__WEBPACK_IMPORTED_MODULE_12__/* .SAVE_PRISMIC_DOCUMENTS */ .w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            funnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
            basket: basket === null || basket === void 0 ? void 0 : basket.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        funnel,
        main,
        basket,
        inStoreText
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        trackPageView({
            documentTitle: 'Search'
        });
        trackEvent({
            category: "Page Search",
            action: "User search for ".concat(search)
        });
        _utils_gtag__WEBPACK_IMPORTED_MODULE_13__/* .tracker */ .ap('searchPage', {
            value: search
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        localStorage.removeItem('Filters');
        if (!isHandleMore && search !== products.currentSearch) {
            var ref, ref26;
            setCurrentSearch1(search);
            if (loadMore && (products === null || products === void 0 ? void 0 : (ref = products.items) === null || ref === void 0 ? void 0 : (ref26 = ref.items) === null || ref26 === void 0 ? void 0 : ref26.length) === 0) {
                getProducts(true);
            } else {
                getProducts();
            }
        }
        setIsHandleMore(false);
    }, [
        products === null || products === void 0 ? void 0 : (ref11 = products.items) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.items) === null || ref12 === void 0 ? void 0 : ref12.length
    ]);
    var heroInfo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref, ref28, ref29, ref30;
        // Parse data from the received page data (if there's a page with the current slug)
        return {
            title: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(pageData === null || pageData === void 0 ? void 0 : pageData.data.title).toUpperCase(),
            // Check if a hero section has been added to the page, and get its background image
            image: (ref29 = pageData === null || pageData === void 0 ? void 0 : (ref = pageData.data) === null || ref === void 0 ? void 0 : (ref28 = ref.body) === null || ref28 === void 0 ? void 0 : ref28.find(function(el) {
                return el.slice_type === 'hero_section';
            })) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.primary) === null || ref30 === void 0 ? void 0 : ref30.background
        };
    }, [
        pageData === null || pageData === void 0 ? void 0 : pageData.data
    ]);
    var handlePrev = function() {
        setCurrentPage(currentPage - 1);
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
        var pageNumber = currentPage - 1;
        router.push({
            pathname: '/search',
            query: {
                q: search,
                currentPage: pageNumber
            }
        }, undefined, {
            shallow: true
        });
    };
    var handleNext = function() {
        setCurrentPage(currentPage + 1);
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
        var pageNumber = currentPage + 1;
        router.push({
            pathname: '/search',
            query: {
                q: search,
                currentPage: pageNumber
            }
        }, undefined, {
            shallow: true
        });
    };
    var handleLoadMore = function() {
        setIsHandleMore(true);
        setCurrentPage(currentPage + 1);
        getProducts(true, true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!products.loading && !stock.loading) {
            setIsLoadingProductsAndStocks(false);
        } else {
            if (!isLoadingProductsAndStocks) {
                setIsLoadingProductsAndStocks(true);
            }
        }
    }, [
        products.loading,
        stock.loading
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref13 = main.data) === null || ref13 === void 0 ? void 0 : ref13.logo,
        doc: main,
        t: t,
        inStoreText: inStoreText,
        metaTitle: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.meta_title_shop),
        metaDescription: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : ref15.meta_description_shop),
        metaKeywords: doc === null || doc === void 0 ? void 0 : (ref16 = doc.data) === null || ref16 === void 0 ? void 0 : ref16.meta_keywords_shop,
        basket: basket,
        takeback: takeback,
        account: accountRes,
        faq: faqRes,
        banner: banner,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("main main--shop ".concat(classes.root), 'search-page'),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Hero_HeroSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    title: t('texts:search_page:title', {
                        search: search,
                        length: products === null || products === void 0 ? void 0 : (ref17 = products.items) === null || ref17 === void 0 ? void 0 : ref17.total
                    }),
                    isMainTitle: true,
                    heroImg: heroInfo.image || (main === null || main === void 0 ? void 0 : (ref18 = main.data) === null || ref18 === void 0 ? void 0 : ref18.hero_banner),
                    heroSettings: main === null || main === void 0 ? void 0 : main.data,
                    isDisplayAccordionOnMobile: isMobileAccordion
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('shop__content', classes.shopContent),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        maxWidth: "xl",
                        className: classes.shopContainer,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            maxWidth: "xl",
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('shop__area', classes.shopArea, isSubscription && columnLayout && classes.shopAreaColumn),
                            "data-stock": stock.loading ? 'loading' : 'loaded',
                            children: [
                                cart.loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes.loader,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loader_Loader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        isLoadingProductsAndStocks && currentPage === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            in: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classes.loader,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loader_Loader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shop_Catalog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            products: products,
                                            loadMore: loadMore,
                                            handleLoadMore: handleLoadMore,
                                            setIsDrawerOpen: setIsDrawerOpen,
                                            currentPage: currentPage,
                                            handlePrev: handlePrev,
                                            handleNext: handleNext,
                                            classic_sub_text: classic_sub,
                                            shopData: doc,
                                            mainData: main,
                                            hideFilters: true,
                                            settings: settings,
                                            hidePrice: settings === null || settings === void 0 ? void 0 : settings.only_add_with_pack,
                                            basket: basket,
                                            cart: cart,
                                            takeback: takeback,
                                            isDisplayedPrice: main === null || main === void 0 ? void 0 : (ref19 = main.data) === null || ref19 === void 0 ? void 0 : ref19.is_product_price_displayed,
                                            isLoadingProductsAndStocks: isLoadingProductsAndStocks,
                                            hideAvailableProductsOnly: true,
                                            isSearch: true
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(Shop));


/***/ }),

/***/ 18919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fh": function() { return /* binding */ promotions_getPromotions; },
  "rs": function() { return /* binding */ setCurrentPromotion; },
  "mW": function() { return /* binding */ setFuturePrice; }
});

// UNUSED EXPORTS: ACTIONS, GET_PROMOTIONS_FAILURE, GET_PROMOTIONS_REQUEST, GET_PROMOTIONS_SUCCESS, SET_CURRENT_PROMOTION, SET_FUTUR_PRICE

// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/promotionsService.ts


var getPromotions = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.promotions */.KU.promotions
    });
};

;// CONCATENATED MODULE: ./redux/actions/promotions.ts

var ACTIONS = {
    GET_PROMOTIONS_REQUEST: 'GET_PROMOTIONS_REQUEST',
    GET_PROMOTIONS_SUCCESS: 'GET_PROMOTIONS_SUCCESS',
    GET_PROMOTIONS_FAILURE: 'GET_PROMOTIONS_FAILURE',
    SET_FUTUR_PRICE: 'SET_FUTUR_PRICE',
    SET_CURRENT_PROMOTION: 'SET_CURRENT_PROMOTION'
};
var GET_PROMOTIONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PROMOTIONS_REQUEST
    };
};
var GET_PROMOTIONS_SUCCESS = function(promotions) {
    return {
        type: ACTIONS.GET_PROMOTIONS_SUCCESS,
        promotions: promotions
    };
};
var GET_PROMOTIONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PROMOTIONS_FAILURE,
        err: err
    };
};
function promotions_getPromotions() {
    return function(dispatch) {
        dispatch(GET_PROMOTIONS_REQUEST());
        return getPromotions().then(function(response) {
            return dispatch(GET_PROMOTIONS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PROMOTIONS_FAILURE(err));
        });
    };
}
var SET_FUTUR_PRICE = function(price) {
    return {
        type: ACTIONS.SET_FUTUR_PRICE,
        price: price
    };
};
var SET_CURRENT_PROMOTION = function(currentPromotion) {
    return {
        type: ACTIONS.SET_CURRENT_PROMOTION,
        currentPromotion: currentPromotion
    };
};
function setCurrentPromotion(currentPromotion) {
    return function(dispatch) {
        dispatch(SET_CURRENT_PROMOTION(currentPromotion));
    };
}
function setFuturePrice(price) {
    return function(dispatch) {
        dispatch(SET_FUTUR_PRICE(price));
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,76142,75436,230,19789,29705,79956,17012,18496,59134,54972,49774,92888,40179], function() { return __webpack_exec__(60881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);